var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 25,
    height: 25,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1875 0 0 0.1875 0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80 15C 44.12 15 15 44.120003 15 80C 15 115.88 44.120003 145 80 145C 115.88 145 145 115.88 145 80C 145 44.120003 115.88 15 80 15zM80 25C 110.36 25 135 49.64 135 80C 135 110.36 110.36 135 80 135C 49.64 135 25 110.36 25 80C 25 49.64 49.64 25 80 25z",
    stroke: "none",
    fill: "#4B4B4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.1989 0 0 1.2342 21.214 28.75)",
    d: "M57.373 18.231C 57.373 21.48762 55.58452 24.496857 52.68125 26.125166C 49.777985 27.753475 46.201015 27.753475 43.297752 26.125166C 40.394485 24.496857 38.606003 21.48762 38.606003 18.231C 38.606003 14.974383 40.394485 11.965144 43.297752 10.336836C 46.20102 8.708528 49.77799 8.708528 52.68125 10.336836C 55.58452 11.965145 57.373 14.974383 57.373 18.231z",
    stroke: "none",
    fill: "#4B4B4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.665 110.96C 90.596 113.69 91.876 114.46 94.992004 114.78L94.992004 114.78L100.00001 114.88L100.00001 120L60.927006 120L60.927006 114.88L66.43001 114.78C 69.72101 114.68 70.51201 113.4 70.75701 110.96L70.75701 110.96L70.75701 80.147C 70.792015 75.268005 64.46101 76.034004 60.00001 76.179L60.00001 76.179L60.00001 71.105L90.66501 70",
    stroke: "none",
    fill: "#4B4B4B",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.a413edc886e7013e4f796e23a3b099bb.svg";
export { ForwardRef as ReactComponent };